import { Controller } from "@hotwired/stimulus";

// Zamknięcie powiadomienia (X) — usuwa element z DOM; wraca po przeładowaniu (brak persystencji).
export default class extends Controller {
  dismiss() {
    this.element.remove();
  }
}
